/// <reference lib="dom" />
export {}; // module scope
import { uForDiameter } from "../shared/heatLossData.js";

type Product = {
  variantId: number; sku: string; name: string; type: string; diameter: number;
  priceCents: number | null; priceText: string; imageUrl: string | null; href: string;
};
type Data = { products: Product[]; diameters: number[]; defaults: { ground: number; hours: number; price: number }; lang: string; strings: Record<string, string> };

const dataEl = document.getElementById("heatloss-data");
const results = document.getElementById("hl-results");
if (dataEl?.textContent && results) {
  try {
    boot(JSON.parse(dataEl.textContent) as Data, results);
  } catch {
    /* malformed */
  }
}

function esc(s: string): string {
  return s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
}
function bumpCount(n: number) {
  document.querySelectorAll("[data-cart-count]").forEach((el) => {
    const c = parseInt(el.textContent || "0", 10) || 0;
    el.textContent = String(c + n);
    (el as HTMLElement).classList.remove("hidden");
  });
}

function boot(data: Data, results: HTMLElement) {
  const s = data.strings;
  const t = (k: string, v?: Record<string, string | number>) =>
    (s[k] ?? k).replace(/\{(\w+)\}/g, (_, key) => (v && key in v ? String(v[key]) : `{${key}}`));
  const locale = data.lang === "de" ? "de-DE" : "en-US";
  const nf0 = new Intl.NumberFormat(locale, { maximumFractionDigits: 0 });
  const nf2 = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 });
  const ids = ["hl-supply", "hl-return", "hl-ground", "hl-length", "hl-hours", "hl-price", "hl-type", "hl-diameter"];
  const els = Object.fromEntries(ids.map((id) => [id, document.getElementById(id) as HTMLInputElement])) as Record<string, HTMLInputElement>;
  for (const id of ids) els[id]?.addEventListener("input", render);
  for (const id of ids) els[id]?.addEventListener("change", render);

  results.addEventListener("click", (e) => {
    const btn = (e.target as HTMLElement).closest("[data-add-cart]") as HTMLButtonElement | null;
    if (!btn || btn.disabled) return;
    void addToCart(Number(btn.dataset.vid), Number(btn.dataset.len), btn);
  });

  render();

  function num(id: string): number {
    return Number(els[id]?.value);
  }

  function render() {
    const supply = num("hl-supply"), ret = num("hl-return"), ground = num("hl-ground");
    const length = num("hl-length"), hours = num("hl-hours"), price = num("hl-price");
    const duo = els["hl-type"]?.value === "duo";
    const diameter = num("hl-diameter");
    const tAvg = (supply + ret) / 2;
    const u = uForDiameter(diameter, duo);
    const wm = Math.max(0, u * (tAvg - ground));
    const totalW = wm * (length > 0 ? length : 0);
    const kWhYear = (totalW * (hours > 0 ? hours : 0)) / 1000;
    const costYear = kWhYear * (price > 0 ? price : 0);

    const matched = data.products.filter(
      (p) => Math.round(p.diameter) === Math.round(diameter) && p.type.toLowerCase().startsWith(duo ? "d" : "s"),
    );
    const hasLen = length > 0;

    const cards = matched
      .map((p) => {
        const addBtn = hasLen && p.priceCents != null
          ? `<button type="button" data-add-cart data-vid="${p.variantId}" data-len="${Math.round(length)}" class="btn-primary mt-2 inline-flex items-center gap-1 text-xs"><i class="fa-solid fa-cart-plus"></i> ${esc(t("prod_add"))} ${nf0.format(length)} m</button>`
          : "";
        return `<div class="card flex gap-3 p-3">
          ${p.imageUrl ? `<img src="${esc(p.imageUrl)}" alt="${esc(p.sku)}" class="h-16 w-16 rounded object-contain"/>` : ""}
          <div class="min-w-0 flex-1">
            <a href="${esc(p.href)}" class="block font-medium text-slate-900">${esc(p.name)}</a>
            <div class="text-xs text-slate-400">${esc(p.sku)} · ${esc(p.priceText)}/m</div>
            ${addBtn}
          </div>
        </div>`;
      })
      .join("");

    results.innerHTML = `
      <div class="card p-4">
        <div class="grid grid-cols-2 gap-3 sm:grid-cols-4 text-center">
          <div><div class="text-2xl font-semibold text-slate-900">${nf2.format(wm)}</div><div class="text-xs text-slate-500">${esc(t("wm"))}</div></div>
          <div><div class="text-2xl font-semibold text-slate-900">${nf0.format(totalW)}</div><div class="text-xs text-slate-500">${esc(t("total_w"))}</div></div>
          <div><div class="text-2xl font-semibold text-slate-900">${nf0.format(kWhYear)}</div><div class="text-xs text-slate-500">${esc(t("kwh_year"))}</div></div>
          <div><div class="text-2xl font-semibold text-brand-700">${nf0.format(costYear)}</div><div class="text-xs text-slate-500">${esc(t("cost_year"))}</div></div>
        </div>
        <p class="mt-2 text-[11px] text-slate-400">${esc(t("estimate_note"))}</p>
      </div>
      ${matched.length ? `<h2 class="mt-4 text-base font-semibold text-slate-700">${esc(t("matched"))}</h2><div class="mt-2 grid gap-3 sm:grid-cols-2">${cards}</div>` : ""}`;
  }

  async function addToCart(variantId: number, unitAmount: number, btn: HTMLButtonElement) {
    if (!variantId || !(unitAmount > 0)) return;
    btn.disabled = true;
    try {
      const r = await fetch("/cart/add", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded", Accept: "application/json" },
        body: new URLSearchParams({ variantId: String(variantId), qty: "1", unitAmount: String(unitAmount) }),
      });
      if (r.ok) {
        bumpCount(1);
        btn.innerHTML = `<i class="fa-solid fa-check"></i> ${esc(t("prod_added"))}`;
      }
    } catch {
      /* ignore */
    } finally {
      setTimeout(() => { btn.disabled = false; }, 1500);
    }
  }
}
